const availableQueryCorrections = (queryData, queryCorrections) => {
  const newQueryCorrections = {};
  Object.keys(queryCorrections).forEach((queryCorrection) => {
    switch (queryCorrection) {
      case 'language':
        newQueryCorrections[queryCorrection] = {
          original: queryData.params.phrase,
          corrected: queryCorrections.phrase,
          language: queryCorrections[queryCorrection].language_code,
          preview: queryCorrections[queryCorrection].total_number_of_results
            ? queryCorrections[queryCorrection]
            : null,
        };
        break;
      case 'phrase':
      case 'family':
      case 'asset_ids':
        newQueryCorrections[queryCorrection] = {
          original: queryData.params[queryCorrection],
          corrected: queryCorrections[queryCorrection],
        };
        break;
      default:
        newQueryCorrections[queryCorrection] = {};
    }
  });

  return newQueryCorrections;
};

export default availableQueryCorrections;
